import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSlideCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 38 38"
    xmlns="http://www.w3.org/2000/svg"
    fill="#919499"
    fillRule="evenodd"
    clipRule="evenodd"
    {...props}
  >
    <path d="M.646 36.647a.5.5 0 0 0 .708.707L19 19.707l17.647 17.647a.5.5 0 0 0 .707-.707L19.707 19 37.354 1.354a.5.5 0 0 0-.707-.708L19 18.293 1.354.646a.502.502 0 0 0-.708.708L18.293 19 .646 36.647z" />
  </svg>
);
const Memo = memo(SvgSlideCross);
export default Memo;
